export default [
  {
    // 获取当前用户
    name: 'getUserInfo',
    url: '/student/student/me',
    method: 'GET'
  },
  {
    // 绑定手机
    name: 'bindMobile',
    url: '/student/student/mobile/bind',
    method: 'POST'
  },
  {
    // 获取微信授权url
    name: 'getWeChat',
    url: '/student/mp/oauth/auth_url',
    method: 'GET'
  },
  {
    // 微信内分享jssdk配置信息获取
    name: 'getWxConfig',
    url: '/student/mp/jssdk/share_info',
    method: 'GET'
  },
  {
    // 发送验证码
    name: 'sendCaptcha',
    url: '/student/sms/captcha/send',
    method: 'POST'
  },
  {
    // 直播间详情
    name: 'getLiveDetail',
    url: '/student/room/{id}',
    method: 'GET'
  },
  {
    // 直播报名
    name: 'liveRegister',
    url: '/student/room/{id}/student',
    method: 'POST'
  },
  {
    // 获取直播链接
    name: 'getLiveUrl',
    url: '/student/room/{id}/entry_url',
    method: 'POST'
  },
  {
    // 直播间分享设置
    name: 'getLiveWeChatShare',
    url: '/student/room/{id}/wechat_share',
    method: 'GET'
  },
];
